import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import TeamsConnection from "../features/teamsConnection/TeamsConnection";

export const teamsRoutes = (
    <Route path={ROUTES.teams} element={<TeamsConnection />} key="teams" />
);
